/// <reference types="vite-plugin-svgr/client" />
import { PlusIcon } from '@heroicons/react/20/solid';
import { InboxIcon } from '@heroicons/react/24/outline';
import { useTranslation } from 'react-i18next';
import Button from '@/components/common/Button';
export interface EmptyProps {
    title?: string;
    description?: string;
    icon?: React.ComponentType<React.SVGProps<SVGSVGElement>>;
    action?: {
        text: string;
        onAdd: (e: React.MouseEvent<HTMLButtonElement>) => void;
    };
}

const Empty = ({ title, description, icon: Icon, action }: EmptyProps) => {
    const { t } = useTranslation('common');
    const iconClassName = 'text-muted-foreground mx-auto size-12';

    return (
        <div className="text-center">
            {Icon ? (
                <Icon className={iconClassName} strokeWidth={1.5} />
            ) : (
                <InboxIcon className={iconClassName} strokeWidth={1.5} />
            )}
            <div className="mt-5 text-base font-medium text-neutral-900">{title || t('common:empty.noProjects')}</div>
            {description && <p className="text-muted-foreground mt-2 text-base font-medium">{description}</p>}
            {action && (
                <div className="mt-6">
                    <Button variant="primary" onClick={action.onAdd}>
                        <div className="flex flex-row items-center justify-center">
                            <PlusIcon aria-hidden="true" className="mr-1.5 -ml-0.5 h-5 w-5" />
                            {action.text}
                        </div>
                    </Button>
                </div>
            )}
        </div>
    );
};

export default Empty;
